import { fromJS  } from 'immutable';

export const State = fromJS({
  isPosting: false,
  isGetting: false,
  errMsg: '',
  isFetching: true,
  isGettingCaseRelated: false,
  caseRelateList: []
});